import { render, staticRenderFns } from "./DetailTrxLogistikComponent.vue?vue&type=template&id=fe3b120c"
import script from "./DetailTrxLogistikComponent.vue?vue&type=script&lang=js"
export * from "./DetailTrxLogistikComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports